import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const months = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря',
];

export const hhmm = date => {
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');

    return `${hh}:${mm}`;
};

/**
 * Дата, месяц
 * @param {Date} date
 * @returns {string} '01.09'
 */
export const dateWithoutYear = date => date.toLocaleString('ru-RU', { day: 'numeric', month: 'numeric' });

/** Дата, месяц, год строкой месяц
 * @param {Date | number} date - дата
 * @return {string} '01.09.2021'
 */
export const ddmmyyyy = date => {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return dd + '.' + mm + '.' + yyyy;
};

/**
 * Дата, месяц, год строкой месяц в родительном падеже
 * @param {Date} date - дата
 * @param {boolean} isGenitive - в родительном
 * @return {string} дата вида '10 января 2020'
 */
export function ddmmmmyyyy(date, isGenitive = true, withUTC = false) {
    if (date instanceof Date) {
        let dd;
        if (withUTC) {
            dd = String(date.getUTCDate()).padStart(2, '0');
        } else {
            dd = String(date.getDate()).padStart(2, '0');
        }
        const mmmm = monthString(date, !isGenitive);
        const yyyy = date.getFullYear();

        return dd + ' ' + mmmm + ' ' + yyyy;
    }
    throw Error('аргумент date должен быть экземплятором класса Date');
}

/**
 * День месяца, числом
 * @param {string} date - дата строкой '03.09.2021'
 * @return {number} день вида 3
 */
export const dd = date => {
    const dateArr = date.split('.');
    return parseInt(dateArr[0], 10);
};

/**
 * Дата, месяц строкой
 * @param {string} date - дата строкой '03.09.2021'
 * @return {string} дата вида '3 сентября'
 */
export const ddmm = date => {
    const dateArr = date.split('.');
    const dd = parseInt(dateArr[0], 10);
    const mm = months[parseInt(dateArr[1] - 1)];

    return dd + ' ' + mm;
};

/**
 * @param {Date} date
 * @param {Boolean} padStart
 * @return {string} '03 сентября'
 */
export function ddmmm(date, padStart = true) {
    let dd = date.getDate().toString();
    if (padStart) {
        dd = dd.padStart(2, '0');
    }
    const mmm = months[date.getMonth()];
    return `${dd} ${mmm}`;
}

/**
 * get month string from date
 * @param {Date} date
 * @param {boolean} plain
 * @returns {string}
 */
export const monthString = (date, plain = true) => {
    switch (date.getMonth()) {
        case 0:
            return plain ? 'январь' : 'января';
        case 1:
            return plain ? 'февраль' : 'февраля';
        case 2:
            return plain ? 'март' : 'марта';
        case 3:
            return plain ? 'апрель' : 'апреля';
        case 4:
            return plain ? 'май' : 'мая';
        case 5:
            return plain ? 'июнь' : 'июня';
        case 6:
            return plain ? 'июль' : 'июля';
        case 7:
            return plain ? 'август' : 'августа';
        case 8:
            return plain ? 'сентябрь' : 'сентября';
        case 9:
            return plain ? 'октябрь' : 'октября';
        case 10:
            return plain ? 'ноябрь' : 'ноября';
        case 11:
            return plain ? 'декабрь' : 'декабря';
    }
};

/**
 * @param {Date} date
 * @param {Number} nextMonthCount
 * @param {Boolean} isPlain
 * @returns {string}
 */
export function getMonthName(date, nextMonthCount = 0, isPlain = true) {
    const innerDate = new Date(date);
    if (nextMonthCount > 0) {
        innerDate.setMonth(innerDate.getMonth() + nextMonthCount);
    }
    return monthString(innerDate, isPlain);
}

/**
 * Месяц в Родительном падеже
 * @param {Number} num - номер месяца начиная с 0
 * @return {string}
 */
export const getNameMonth = num => {
    return months[num];
};

/**
 * Преобразование даты формата 11.12.2019 в формат 2019-12-11 или наоборот
 * @param {string} date - дата в формате 11.12.2019 или 2019-12-11
 * @return {string}
 */
export const formatDate = (date) => {
    // разделитель - тире или точка
    return date.indexOf('-') !== -1
        ? date.split('-').reverse().join('.')
        : date.split('.').reverse().join('-');
};

/**
 * Парсим дату вида "25.06.2020 12:38:30", "25.06.2020 4:38" или "25.06.2020"
 * @param  {string} string
 * @return {Date}
 */
export function parseRusDate(string) {
    //                1        2        3      4  5       6       7
    const regExp = /^(\d{2})\.(\d{2})\.(\d{4})(\s(\d{1,2}):(\d{2}):?(\d{2})?)?$/g;
    const matched = regExp.exec(string.trim());

    if (matched == null) {
        throw Error('Некорректная строка c датой');
    }

    if (matched[4] == null) {
        return new Date(Date.UTC(matched[3], +matched[2] - 1, matched[1], 0, 0, 0));
    } else {
        return new Date(Date.UTC(matched[3], +matched[2] - 1, matched[1], matched[5], matched[6], matched[7] || 0));
    }
}

/**
 * @param {Date} date
 * @return {string} "2020-12-20"
 */
export function toISODateString(date) {
    return dayjs(date).format('YYYY-MM-DD');
}


/** TODO - аналог addDays убрать дубль, ps:addDays - более понятное название, оставить его
 * Новая дата + count дней
 * @deprecated use addDays
 * @param {number} count
 * @param {Date} date
 * @return {Date}
 */
export function dateNextDay(count, date = new Date()) {
    const now = new Date(date);
    now.setDate(now.getDate() + count);
    return now;
}

/** TODO - аналог dateNextDay убрать дубль
 * Добавляет к дате указанное кол-во дней
 * @param {Date} date
 * @param {number} days
 * @returns {Date}
 */
export const addDays = (date, days) => {
    const dateTo = new Date(date);
    dateTo.setDate(dateTo.getDate() + days);
    return dateTo;
};

export const generateArrayOfYears = (threshold = 9) => {
    const max = new Date().getFullYear();
    const min = max - threshold;
    const years = [];

    for (let i = max; i >= min; i--) {
        years.push(i);
    }

    return years;
};

/** Вычисление даты с прибавлением нескольких месяцев
 * @param {number | string | Date} dateValue - дата
 * @param {number} amount - количество месяцев
 * @return {Date}
 */
export const addMonths = (dateValue, amount) => {
    const date = new Date(dateValue);
    const dayOfMonth = date.getDate();

    const endOfDesiredMonth = new Date(dateValue);
    endOfDesiredMonth.setTime(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();

    if (dayOfMonth >= daysInMonth) {
        return endOfDesiredMonth;
    } else {
        date.setFullYear(
            endOfDesiredMonth.getFullYear(),
            endOfDesiredMonth.getMonth(),
            dayOfMonth,
        );
        return date;
    }
};

/** Приведение даты к формату 'ru-RU'
 * @param {number | string | Date} date - дата
 * @return {string} '22.30.15'
 */
export const dateToLocaleRu = (date) => new Date(date).toLocaleDateString('ru-RU');

export const daysDifinition = {
    yesterday: 'вчера',
    today: 'сегодня',
    tomorrow: 'завтра',
    afterTomorrow: 'послезавтра',
};

/**
 * Возвращает Сегодня/Завтра/Послезавтра/Вчера
 * @param {number} diffDay - разница в днях между датами ("11.10.2020" - "10.10.2020" равна 1 день)
 * @return {string} 'Сегодня' || ''
 */
export const getDateDefinition = (diffDay) => {
    switch (true) {
        case (diffDay === -1):
            return daysDifinition.yesterday;
        case (diffDay === 0):
            return daysDifinition.today;
        case (diffDay === 1):
            return daysDifinition.tomorrow;
        case (diffDay === 2):
            return daysDifinition.afterTomorrow;
        default:
            return '';
    }
};
